import React from "react";
import "./Overview.css";
import img117 from "../assets/img117.jpg";   
import img118 from "../assets/img118.jpg";
import img119 from "../assets/img119.jpg";

function Overview() {
  return (
    <div className="sustainability-container">
      <h2 className="sustainability-title">Three equities of sustainability</h2>
      <div className="equities-grid">
        {/* Environmental */}
        <div className="equity-card tilt-left">
          <h3>Environmental equity</h3>
          <p>
            The rate of pollution and consumption do not outpace the rate of
            replenishment by nature and human restoration, respectively.
          </p>
          <img src={img117} alt="Environmental" />
        </div>

        {/* Social */}
        <div className="equity-card tilt-center">
          <h3>Social equity</h3>
          <p>
            Society needs sufficient resources to meet acceptable level
            standards in terms of healthcare, education, and quality of life,
            while upholding diversity, labor, and cultural rights.
          </p>
          <img src={img118} alt="Social" />
        </div>

        {/* Economic */}
        <div className="equity-card tilt-right">
          <h3>Economic equity</h3>
          <p>
            Creating equitable growth for every individual without harming the
            environment through sustainable way.
          </p>
          <img src={img119} alt="Economic" />
        </div>
      </div>
    </div>
  );
}

export default Overview;
